import { NgModule } from '@angular/core';
import { McRcEventsService } from './services/rcEvents.service';

@NgModule({
    providers: [
        McRcEventsService
    ]
})
export class McRcModule { }
